<template>
  <div
    :class="['w-full flex flex-col mt-6 md:mt-6 mb-0 md:my-6 items-center', claseFondoFinal]"
    :style="estiloFondo"
  >
    <div class="max-w-[76rem] flex flex-col w-full relative">
      <div class="swiper-wrapper-container md:px-6 relative">
        <Swiper
          v-if="resenas.length > 0"
          ref="swiperRef"
          :slides-per-view="3"
          :centered-slides="true"
          :space-between="20"
          :slides-per-group="1"
          :loop="resenas.length > 1"
          :initial-slide="slideInicial"
          :autoplay="{ delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true }"
          class="my-swiper py-10"
          :modules="[SwiperNavigation, SwiperPagination, SwiperAutoplay]"
          :navigation="resenas.length > 1"
          :breakpoints="{
            320: { slidesPerView: 1, initialSlide: 0 },
            1024: { slidesPerView: Math.min(2, resenas.length), initialSlide: 0 },
            1280: { slidesPerView: Math.min(3, resenas.length), initialSlide: slideInicial }
          }"
        >
          <SwiperSlide
            v-for="(resena, index) in resenas"
            :key="resena.clave || index"
            class="md:px-2 transition-all duration-500 flex justify-center"
          >
            <ResenasCard :data="resena" />
          </SwiperSlide>
        </Swiper>

        <div v-else-if="cargado" class="py-10 text-center text-sm text-gray-500">
          No hay reseñas disponibles para mostrar.
        </div>

        <div v-else class="py-10 text-center text-sm text-gray-500">
          Cargando reseñas...
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ResenasCard from '~/components/newhome/resenas/ResenasCard.vue'
import { NEGOCIOS } from '~/constants/negocios'

const props = defineProps({
  background_color: {
    type: String,
    default: ''
  }
})

const modoSistema = useState('modo_sistema')
const resenas = ref([])
const cargado = ref(false)
const swiperRef = ref(null)

const claseFondoPorDefecto = computed(() => {
  return modoSistema.value === NEGOCIOS.BATERIAS
    ? 'bg-BLANCO_LEON'
    : 'bg-GRIS_CLARO'
})

const claseFondoFinal = computed(() => {
  const valor = (props.background_color || '').trim()

  if (!valor) {
    return claseFondoPorDefecto.value
  }

  if (valor.startsWith('bg-')) {
    return valor
  }

  return claseFondoPorDefecto.value
})

const estiloFondo = computed(() => {
  const valor = (props.background_color || '').trim()

  if (!valor || valor.startsWith('bg-')) {
    return {}
  }

  return {
    backgroundColor: valor
  }
})

const slideInicial = computed(() => {
  return resenas.value.length >= 3 ? 1 : 0
})

onMounted(async () => {
  try {
    const respuesta = await fetch('/api/resenas')

    if (!respuesta.ok) {
      throw new Error(`Error HTTP ${respuesta.status}`)
    }

    const data = await respuesta.json()
    const lista = Array.isArray(data?.resenas) ? data.resenas : []

    resenas.value = lista.map((resena) => ({
      ...resena,
      clave: [
        resena.sucursal?.codigo || '',
        resena.autor || '',
        resena.fechaUnix || '',
        resena.rating || ''
      ].join('|')
    }))

    //console.log('Reseñas cargadas:', data)
  } catch (error) {
    console.error('Error cargando reseñas:', error)
    resenas.value = []
  } finally {
    cargado.value = true
  }
})

onBeforeUnmount(() => {
  if (swiperRef.value?.$el?.swiper) {
    try {
      swiperRef.value.$el.swiper.destroy(true, true)
    } catch (error) {
      // No hacer nada
    }
  }
})
</script>

<style scoped>
:deep(.swiper-wrapper) {
  align-items: center;
}

.my-swiper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrapper-container {
  position: relative;
}

:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  display: flex;
  width: 40px;
  height: 40px;
  color: #333;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
}

:deep(.swiper-button-prev) {
  left: 10px;
}

:deep(.swiper-button-next) {
  right: 10px;
}

:deep(.swiper-button-prev::after),
:deep(.swiper-button-next::after) {
  font-size: 20px;
  font-weight: bold;
}

:deep(.swiper-button-prev:hover),
:deep(.swiper-button-next:hover) {
  transform: scale(1.1);
  background: white;
}

@media screen and (max-width: 768px) {
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    display: flex;
    width: 35px;
    height: 35px;
  }

  :deep(.swiper-button-prev::after),
  :deep(.swiper-button-next::after) {
    font-size: 16px;
  }

  :deep(.swiper-button-prev) {
    left: 5px;
  }

  :deep(.swiper-button-next) {
    right: 5px;
  }
}

.swiper-slide {
  transform: scale(0.6);
  transition: transform 0.5s;
}

.swiper-slide-active {
  transform: scale(1);
  z-index: 10;
}
</style>